import React, { useMemo } from 'react';

import { StatusIcon as PrismUIStatusIcon } from '@nutanix-ui/prism-reactjs';
import type { StatusIconProps as PrismUIStatusIconProps } from '@nutanix-ui/prism-reactjs/lib/components/v2/Badge/StatusIcon';
import { StatusIconTypes } from '@nutanix-ui/prism-reactjs/lib/components/v2/Badge/StatusIcon';

import PopUpPlacement from '../../../constants/placement';
import type { TooltipContentProps } from '../Tooltip/Tooltip';
import { TooltipAppearance } from '../Tooltip/Tooltip';

export type StatusIconProps = PrismUIStatusIconProps & {
  message?: React.ReactNode;
  type: StatusIconTypes;
  tooltipPlacement?: PopUpPlacement;
  tooltipAppearance?: TooltipAppearance;
  tooltipContentProps?: TooltipContentProps;
};

export { StatusIconTypes };

export default function StatusIcon({
  tooltipPlacement = PopUpPlacement.BOTTOM_START,
  tooltipAppearance = TooltipAppearance.SECONDARY,
  tooltipContentProps,
  ...props
}: React.PropsWithChildren<StatusIconProps>) {
  const content = useMemo(() => props.message ?? props.children, [props.message, props.children]);

  return (
    <PrismUIStatusIcon
      {...props}
      tooltipProps={{
        oldTooltip: false,
        appearance: tooltipAppearance,
        placement: tooltipPlacement,
        contentProps: tooltipContentProps,
        content,
      }}
    />
  );
}
